import { atom } from 'jotai';

export const pagesAtom = atom([]);
export const activeTabIdAtom = atom('default');

export const skipNextNavigationRef = { current: false };
